import i18n from "locales/i18n";
import { MdArrowBackIosNew } from "react-icons/md";
import { MdArrowForwardIos } from "react-icons/md";
import { IoMdArrowDropdown } from "react-icons/io";
import {
  Dispatch,
  RefObject,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from "react";
import { lngProps } from "interface";
import { days, mths } from "components/utils/option";
import { getKoreanCalendarDates } from "components/utils/comm";
import "./datepick.scss";

type IProps = {
  datePickRef: RefObject<HTMLDivElement>;
  calendarRef: RefObject<HTMLDivElement>;
  range: string[];
  setRange: Dispatch<SetStateAction<string[]>>;
  dateRange: Array<string>;
  onPickDate?: (dates: Array<string>) => void;
};

export default function Calenader({
  datePickRef,
  calendarRef,
  range,
  setRange,
  dateRange,
  onPickDate,
}: IProps) {
  const lng = i18n.language;

  const udRowRef = useRef<HTMLButtonElement>(null);

  const [now, setNow] = useState(new Date());
  const [isYear, setIsYear] = useState(false);
  const [isMonth, setIsMonth] = useState(false);

  const calendarDates = getKoreanCalendarDates(now);

  const year = now.getFullYear();
  const month = now.getMonth() + 1;

  const nextMonth = new Date(now.getFullYear(), now.getMonth() + 2, 0);

  const prevMonth = new Date(now.getFullYear(), now.getMonth(), 0);

  const outSideClick = (e: any) => {
    if (
      datePickRef.current &&
      !datePickRef.current.contains(e.target) &&
      calendarRef.current
    ) {
      calendarRef.current.hidden = true;
    }
  };

  useEffect(() => {
    document.addEventListener("click", outSideClick);

    return () => {
      document.removeEventListener("click", outSideClick);
    };
  }, []);

  const list = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const lastyear = list.map((li) => {
    return {
      year: year - li,
      crr: false,
    };
  });

  const nextyear = list.map((li) => {
    return { year: year + li, crr: false };
  });

  const monthList = [
    ...lastyear.reverse(),
    {
      year: year,
      crr: true,
    },
    ...nextyear,
  ];

  useEffect(() => {
    const currentYear = document.getElementById("crr-year");
    currentYear?.scrollIntoView({ behavior: "instant" });
    const next = currentYear?.nextSibling as HTMLUListElement;
    next.hidden = false;
  }, [isYear]);

  return (
    <>
      <div className="calendar" ref={calendarRef}>
        <div className="calendar _title">
          <button
            onClick={(e) => {
              e.preventDefault();
              setNow(prevMonth);
            }}
          >
            {<MdArrowBackIosNew size={14} />}
          </button>
          <button
            ref={udRowRef}
            className="flex items-end"
            onClick={(e) => {
              e.preventDefault();
              setIsYear(!isYear);
              setIsMonth(!isMonth);
              const icon = e.currentTarget.children[1] as HTMLElement;

              const style = icon.style.transform;

              if (style.includes("rotate(0deg)") || !style) {
                icon.style.transform = "rotate(180deg)";
              }
              if (style.includes("rotate(180deg)")) {
                icon.style.transform = "rotate(0deg)";
              }
            }}
          >
            <span>
              {year}.{month}
            </span>
            <IoMdArrowDropdown size={18} />
          </button>

          <button
            onClick={(e) => {
              e.preventDefault();
              setNow(nextMonth);
            }}
          >
            {<MdArrowForwardIos size={14} />}
          </button>
        </div>
        <div className="">
          <ul className="day">
            {days.map((day) => {
              return <li key={day.value}>{day.ko}</li>;
            })}
          </ul>

          <ul className="month" hidden={isYear}>
            {calendarDates.map((month, index) => {
              return (
                <li
                  key={index}
                  className="cursor-pointer"
                  id={month.fullDate}
                  data-today={month.isToday.toString()}
                  data-islast={!month.isCurrentMonth}
                  data-issun={month.day}
                  data-date={month.date}
                  data-isstart={
                    dateRange.includes(month.fullDate) ||
                    (dateRange[0] || range[0]) === month.fullDate
                  }
                  onClick={() => {
                    if (range.length === 0) {
                      setRange([month.fullDate]);
                      onPickDate && onPickDate([month.fullDate, ""]);
                    }
                    if (range.length === 1) {
                      const days =
                        Number(month.fullDate) > Number(range[0])
                          ? [...range, month.fullDate]
                          : [month.fullDate, ...range];
                      setRange(days);
                      onPickDate && onPickDate(days);
                    }
                    if (range.length === 2) {
                      setRange([month.fullDate]);
                      onPickDate && onPickDate([month.fullDate, ""]);
                    }
                  }}
                >
                  <span>{month.dateSt}</span>
                </li>
              );
            })}
          </ul>

          {/* 달력 연도 월  */}
          <ul className={isMonth ? "years" : "hidden"}>
            {monthList.map((li) => {
              return (
                <li key={li.year} className="year">
                  <button
                    id={li.crr || li.year === year ? "crr-year" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      const next = e.currentTarget
                        .nextSibling as HTMLUListElement;

                      if (next.hidden) {
                        return (next.hidden = false);
                      }
                      if (!next.hidden) {
                        return (next.hidden = true);
                      }
                    }}
                  >
                    {li.year}
                  </button>
                  <ul hidden>
                    {mths.map((item: lngProps) => {
                      return (
                        <li
                          key={item.value}
                          data-crr={li.crr && item.value === month}
                          onClick={(e) => {
                            const selected = new Date(
                              li.year,
                              Number(item.value),
                              0
                            );

                            const parent = e.currentTarget.closest(
                              "ul"
                            ) as HTMLUListElement;
                            if (parent) {
                              parent.hidden = true;
                            }
                            setNow(selected);
                            setIsMonth(!isMonth);
                            setIsYear(!isYear);
                            const icon = udRowRef.current
                              ?.children[1] as SVGAElement;

                            const styels = icon.style.transform;

                            if (styels.includes("rotate(0deg)")) {
                              icon.style.transform = "rotate(180deg)";
                            }
                            if (styels.includes("rotate(180deg)")) {
                              icon.style.transform = "rotate(0deg)";
                            }
                          }}
                        >
                          {item[lng as keyof lngProps]}
                        </li>
                      );
                    })}
                  </ul>
                </li>
              );
            })}
          </ul>
        </div>
        {/* </div> */}
      </div>
    </>
  );
}
